document.addEventListener("DOMContentLoaded", ()=>{
    const form = document.getElementById("inquiryForm");
    const status = document.getElementById("formStatus");
    // поля, которые нужно проверить (основная форма)
    const fields = [
        "inquiryType",
        "howToAddress",
        "fullName",
        "email",
        "role",
        "maxPrice",
        "minSize"
    ];
    function setError(fieldId, message) {
        const input = document.getElementById(fieldId);
        if (!input) return;
        const group = input.closest(".form__group");
        if (!group) return;
        const errorSpan = group.querySelector(".form__error");
        if (!errorSpan) return;
        input.classList.add("error");
        errorSpan.textContent = message;
    }
    function clearError(fieldId) {
        const input = document.getElementById(fieldId);
        if (!input) return;
        const group = input.closest(".form__group");
        if (!group) return;
        const errorSpan = group.querySelector(".form__error");
        if (!errorSpan) return;
        input.classList.remove("error");
        errorSpan.textContent = "";
    }
    // Простая проверка одного поля (универсальная)
    function validateField(fieldId) {
        const el = document.getElementById(fieldId);
        if (!el) return true;
        const value = el.value.trim();
        clearError(fieldId);
        // обязательность
        if (!value) {
            setError(fieldId, "\u042D\u0442\u043E \u043F\u043E\u043B\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E");
            return false;
        }
        // селекты
        if (el.tagName === "SELECT" && value === "") {
            setError(fieldId, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0430\u0440\u0438\u0430\u043D\u0442 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430");
            return false;
        }
        // email
        if (fieldId === "email" || fieldId === "footerEmail") {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(value)) {
                setError(fieldId, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 email");
                return false;
            }
        }
        // числа
        if (fieldId === "maxPrice" || fieldId === "minSize") {
            const num = Number(value);
            if (!Number.isFinite(num) || num <= 0) {
                setError(fieldId, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0447\u0438\u0441\u043B\u043E \u0431\u043E\u043B\u044C\u0448\u0435 0");
                return false;
            }
        }
        return true;
    }
    if (form && status) form.addEventListener("submit", (e)=>{
        e.preventDefault();
        status.textContent = "";
        status.classList.remove("error");
        let isValid = true;
        fields.forEach((fieldId)=>{
            const ok = validateField(fieldId);
            if (!ok) isValid = false;
        });
        if (!isValid) {
            status.textContent = "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0444\u043E\u0440\u043C\u0443.";
            status.classList.add("error");
            return;
        }
        // тут могла бы быть отправка данных на сервер
        status.textContent = "\u0414\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B!";
        form.reset();
        // убираем подсветку ошибок после успешной отправки
        fields.forEach((fieldId)=>clearError(fieldId));
    });
    // Форма в футере (базовая валидация)
    const footerForm = document.getElementById("footerForm");
    const footerStatus = document.getElementById("footerFormStatus");
    const footerFields = [
        "footerName",
        "footerEmail",
        "footerMessage"
    ];
    if (footerForm && footerStatus) footerForm.addEventListener("submit", (e)=>{
        e.preventDefault();
        footerStatus.textContent = "";
        footerStatus.classList.remove("error");
        let isValid = true;
        footerFields.forEach((fieldId)=>{
            const ok = validateField(fieldId);
            if (!ok) isValid = false;
        });
        if (!isValid) {
            footerStatus.textContent = "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u0439 \u0444\u043E\u0440\u043C\u044B.";
            footerStatus.classList.add("error");
            return;
        }
        footerStatus.textContent = "\u0421\u043F\u0430\u0441\u0438\u0431\u043E! \u0412\u0430\u0448\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430.";
        footerForm.reset();
        footerFields.forEach((fieldId)=>clearError(fieldId));
    });
});

//# sourceMappingURL=public.a2491e9e.js.map
